import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import qs from 'qs';

import UserDeviceContracts from './UserDeviceContracts';

import { fetchUserDeviceContracts } from 'actions/deviceContracts';
import { getUserDeviceContracts, getPageCount } from 'reducers';

const mapStateToProps = (state, { location: { search } }) => {
  const { deviceContractsPage = 1 } = qs.parse(search, {
    ignoreQueryPrefix: true,
  });
  return {
    deviceContracts: getUserDeviceContracts(state),
    pageCount: getPageCount(
      state,
      'deviceContracts',
      `fetchByUser`,
      deviceContractsPage,
    ),
    page: deviceContractsPage,
    viewUrl: (deviceContract) => `/device/contracts/${deviceContract.id}/view`,
  };
};

const mapDispatchToProps = {
  fetchUserDeviceContracts,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserDeviceContracts),
);
